import React, { useEffect, useState } from "react"
import { get, chunk, isEmpty } from "lodash"
import { useDispatch } from "react-redux"
import { tableColumns } from "config/table_columns"
import { BaseTable } from "components/molecules/table"
import { Tab } from "components/atoms/btn/tab"
import { Btn } from "components/atoms/btn"
import { changeSymbol, changeSpModalSymbol } from "redux/ducks/Chart"

import { APIResponse } from "redux/apis/types"
import { Pagination } from "components/molecules/pagination"
import { PAGE_NUM } from "config/const"
import { ChartInputNumeric } from "components/atoms/chart/parts/ChartInputNumeric"
import * as Formatter from "utils/Formatter"
import { checkIsSp, open_symbol_detail } from "utils/util"
import { SpDetailTable } from "components/molecules/table/spTable"
import store from "redux/store"

type REITPropsType = {
  title?: string
  data?: Array<APIResponse.Res>
  currentPage: number
  totalCount: number
  changePage: Function
  changeData: Function
  activeTab: number
  changeTab: Function
  canvasId: string
  dataList: Array<Array<object>>
  rateData?: APIResponse.Res
  calcData?: number
  setCalcData?: Function
  numericSpinnerStatus?: number
  changeNumericSpinnerStates?: Function
  refreshFlag?: boolean
  setRefreshFlag: Function
}
type TabType = Array<{ id: number; name: string }>

export const ReitBase: React.FC<REITPropsType> = props => {
  const dispatch = useDispatch()
  const tabList: TabType = [{ id: 0, name: "東証" }, { id: 1, name: "名証" }]
  const [currentPosition, changePosition] = useState<number>(0)
  const isSp = checkIsSp()

  return (
    <div className="tab-wrapper">
      <Tab
        className="tab-panel"
        list={tabList}
        active={props.activeTab}
        onChange={(num: number) => {
          props.changeTab(num)
          props.changePage(0)
          props.changeData(0)
          changePosition(0)
          props.setRefreshFlag(true)
        }}
      />
      <BaseTable
        className="table-list-view table-liquid-cell"
        list={tableColumns.data.etf}
        data={props.data}
        active={currentPosition}
        onClick={(row: object, i: number) => {
          {
            isSp
              ? dispatch(changeSpModalSymbol(row))
              : dispatch(changeSymbol(props.canvasId, row))
          }
          props.changeData(i)
          changePosition(i)
        }}
      />
      {!isSp && (
        <Pagination
          total={props.totalCount}
          list={props.data}
          current={props.currentPage}
          page={PAGE_NUM.PAGE_10}
          changePage={(num: number) => {
            props.changePage(num)
            props.changeData(0)
            changePosition(0)
          }}
        />
      )}
    </div>
  )
}

export const Adr: React.FC<REITPropsType> = props => {
  const isSp = checkIsSp()

  const defaultRate = Formatter.number(
    String(get(props.rateData, "Price")),
    get(props.rateData, "NumberOfDecimals"),
    "floor",
    false,
    "",
    true
  )

  useEffect(() => {
    if (isEmpty(props.rateData)) return
    props.changeNumericSpinnerStates(props.numericSpinnerStatus || defaultRate)
  }, [props.rateData])

  const data = chunk(props.data, PAGE_NUM.PAGE_20)

  return (
    <div>
      <div className="control-row filter-control-row">
        <div className="form-group">円換算レート</div>
        <div className="form-group">
          <ChartInputNumeric
            defaultValue={props.numericSpinnerStatus || ""}
            step={1}
            min={0.01}
            max={999999}
            decimalDigits={get(props.rateData, "NumberOfDecimals")}
            setValue={props.changeNumericSpinnerStates}
          />
        </div>
        <div className="form-group">
          <Btn
            className="btn-primary btn-shaped"
            name="計算"
            onClick={() => props.setCalcData(props.numericSpinnerStatus)}
          />
          <Btn
            className="btn-primary btn-shaped"
            name="リセット"
            onClick={() => {
              props.setCalcData(defaultRate)
              props.changeNumericSpinnerStates(defaultRate)
            }}
          />
        </div>
      </div>
      {!isSp ? (
        <BaseTable
          className="table-list-view table-liquid-cell"
          list={tableColumns.data.adr}
          data={data[props.currentPage]}
          onClick={(data: object) => open_symbol_detail(data)}
        />
      ) : (
        <SpDetailTable
          headerList={tableColumns.data.adrSp.header}
          bodyList={tableColumns.data.adrSp.body}
          data={props.data}
          onClick={(data: object) => store.dispatch(changeSpModalSymbol(data))}
        />
      )}
      {!isSp && (
        <Pagination
          list={props.data}
          current={props.currentPage}
          page={PAGE_NUM.PAGE_20}
          changePage={(num: number) => {
            props.changePage(num)
          }}
        />
      )}
    </div>
  )
}
